import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'permissionPipe'
})
export class PermissionPipePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {

    let result="inconnu";

    if(value =="SiteCollaborator"){
      result ="Collaborateur";
     return result;
    }else if(value =="SiteManager")
    {
      result ="Gestionnaire";
      return result;
    }
    else if(value =="SiteContributor")
    {
      result ="Contributeur";
     return result;

    }
    else if(value =="SiteConsumer")
    {
      result ="Lecteur";
      return result;
    }else if(value =="ReadPermissions"){
      result="Lecteur";
      return result;
    }
    return result;
  }



}
